// src/TirePage.js
import React from 'react';

export default function TirePage({ tireData }) {
  const containerStyle = {
    width: '8.5in',
    minHeight: '11in',
    margin: '0 auto',
    padding: '0.3in',
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
    fontFamily: 'Arial, sans-serif',
    position: 'relative',
  };

  const headingStyle = {
    color: '#153BC6',
    borderBottom: '1px solid #153BC6',
    paddingBottom: '5px',
    marginBottom: '10px',
    fontSize: '1.25rem',
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
  };

  const thStyle = {
    borderBottom: '1px solid #ccc',
    textAlign: 'left',
    padding: '6px 8px',
    backgroundColor: '#f7f7f7',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    fontWeight: 'bold',
    width: '20%',
  };

  const tdStyle = {
    borderBottom: '1px solid #ddd',
    padding: '6px 8px',
    verticalAlign: 'top',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
  };

  const disclaimerContainerStyle = {
    marginTop: '20px',
    padding: '10px',
    borderLeft: '5px solid #153BC6',
    backgroundColor: '#f9f9f9',
  };

  const disclaimerHeadingStyle = {
    color: '#153BC6',
    fontSize: '1rem',
    marginBottom: '6px',
  };

  return (
    <div className="report-page" style={containerStyle}>
      <h2 style={headingStyle}>Tire &amp; Brake Inspection</h2>
      {(!tireData || tireData.length === 0) ? (
        <p>No tire data found.</p>
      ) : (
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Location</th>
              <th style={thStyle}>Mfr / Model</th>
              <th style={thStyle}>Size</th>
              <th style={thStyle}>Tread Depths</th>
              <th style={thStyle}>Brake Depth</th>
            </tr>
          </thead>
          <tbody>
            {tireData.map((row) => {
              const treadOuter = row.TreadDepthOuter ? `${row.TreadDepthOuter}/32` : '';
              const treadMiddle = row.TreadDepthMiddle ? `${row.TreadDepthMiddle}/32` : '';
              const treadInner = row.TreadDepthInner ? `${row.TreadDepthInner}/32` : '';
              const brakeDepth = row.BrakePadOuterDepth
                ? `${row.BrakePadOuterDepth} mm`
                : '--';

              return (
                <tr key={row.InspectionTireId}>
                  <td style={tdStyle}>{row.Location || ''}</td>
                  <td style={tdStyle}>
                    {row.Manufacturer || ''}<br />
                    {row.Model || ''}
                  </td>
                  <td style={tdStyle}>{row.Size || ''}</td>
                  <td style={tdStyle}>
                    Outer: {treadOuter}<br />
                    Middle: {treadMiddle}<br />
                    Inner: {treadInner}
                  </td>
                  <td style={tdStyle}>
                    Depth: {brakeDepth}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      <div style={disclaimerContainerStyle}>
        <h3 style={disclaimerHeadingStyle}>Tire Notes</h3>
        <p style={{ margin: '6px 0' }}>
          Tread depth is typically measured in 32nds of an inch. New tires often measure around 10/32. 
          Many safety standards recommend replacing tires at or below 2/32 to maintain safe traction.
        </p>
        <p style={{ margin: '6px 0' }}>
          Tires have a date stamp showing when they were made. Most tire makers recommend replacing tires after 6 years, even if they have good tread.
        </p>
        <p style={{ margin: '6px 0' }}>
          Why? Rubber dries out and can crack or fail with age—even if the tire looks fine.
        </p>

        <h3 style={disclaimerHeadingStyle}>Brake Notes</h3>
        <p style={{ margin: '6px 0' }}>
        Brake pad thickness is often measured in millimeters (mm). New pads may start around 10–12 mm. 
          It's generally advised to consult a qualified professional if pad thickness is below 3 mm or 
          if you notice any braking issues.
        </p>
        <p style={{ margin: '6px 0' }}>
          Brake pad thickness is measured on the outer pad only.
        </p>
        <p style={{ margin: '6px 0' }}>
          As our inspections are non‑invasive, we may not be able to access brake pads in all vehicles. We measure only the outer pads; while inner and outer pads typically wear evenly, a qualified professional must remove the wheel to inspect inner pads.
        </p>
      </div>

      <div style={{ position: 'absolute', bottom: 10, right: 10 }}>
        <img src="/logo.png" alt="Company Logo" style={{ height: 40 }} />
      </div>
    </div>
  );
}
